import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from '../services/data.service';
import { MessageService } from '../services/message.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-users-form',
  templateUrl: './users-form.component.html',
  styleUrls: ['./users-form.component.scss'],
})
export class UsersFormComponent implements OnInit {
  url: string = 'users';
  id!: string;
  form!: FormGroup;
  roles: Array<any> = [];
  indicatives: Array<any> = [];
  countries: Array<any> = [];
  departments: Array<any> = [];
  imgModal: string;
  showModalImg = false;
  imgUser: string;
  apiUrl = environment.apiUrl;
  update = false;
  isLoading = false;

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
    private http: HttpClient
  ) {
    this.form = this.fb.group({
      username: ['', [Validators.required]],
      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      identification: [''],
      rut: [''],
      role: ['', [Validators.required]],
      //department: ['', [Validators.required]],
      status: [''],
      password: [''],
      phone: [''],
      indicative: [''],
      type: [''],
      img: [''],
      twoFAEnabled: [true],
      address: [''],
      apt: [''],
      city: [''],
      state: [''],
      country: [''],
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.selectDataRoles();

      this.id = params['id'];

      if (this.id) {
        //this.selectDataRoles();
        this.getData();
      }
    });

    this.indicatives = [
      '+1',
      '+57',
      '+52',
      '+55',
      '+54',
      '+56',
      '+58',
      '+34',
      '+44',
    ];

    this.departments = ['Development', 'Finance', 'Logistics', 'Dispatch'];

    this.cities();
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.id) {
      this.updateData();
    } else {
      this.createData();
    }
  }

  getData(): void {
    this.dataService.getData(`${this.url}/${this.id}`).subscribe((response) => {
      console.log('getData', response);
      this.form.patchValue({
        username: response.username,
        firstname: response.firstname,
        lastname: response.lastname,
        identification: response.identification,
        rut: response.rut,
        role: response.role,
        department: response.department,
        status: response.status,
        phone: response.phone,
        indicative: response.indicative,
        type: response.type,
        img: response.img,
        address: response.address,
        apt: response.apt,
        city: response.city,
        state: response.state,
        country: response.country,
      });

      this.imgUser = response.img
        ? `${this.apiUrl}/uploads/${response.img}`
        : './assets/img/faces/marc.jpg';
    });
  }

  createData(): void {
    const formData = {
      ...this.form.value,
    };

    this.dataService
      .postData(`${this.url}/add`, formData)
      .subscribe((response) => {
        console.log('response', response);
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.router.navigateByUrl('/administracion');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  updateData(): void {
    this.isLoading = true;
    const formData = {
      ...this.form.value,
    };

    this.dataService
      .putData(`${this.url}/edit/${this.id}`, formData)
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.isLoading = false;
          this.router.navigateByUrl('/administracion');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  selectDataRoles(): void {
    this.dataService.getData('roles/select').subscribe((response) => {
      console.log('response.roles', response);
      //this.roles = response.data;
      this.roles = response.data.filter(
        (role: any) =>
          role.name.toLowerCase() !== 'driver' &&
          role.name.toLowerCase() !== 'client'
      );
    });
  }

  openEmail(email: string) {
    if (!email) return;

    const subject = encodeURIComponent('Contacto desde sistema');
    const body = encodeURIComponent(
      'Hola,\n\nMe comunico contigo desde el sistema.\n\nSaludos.'
    );
    //const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${subject}&body=${body}`;
    const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}`;

    const chooserUrl = `https://accounts.google.com/AccountChooser?continue=${encodeURIComponent(
      gmailComposeUrl
    )}`;

    window.open(chooserUrl, '_blank');
  }

  /* formatPhone() {
    const phoneNumber = (this.form.get('phone')?.value || '').replace(
      /[^\d]/g,
      ''
    );

    const phoneNumberLength = (this.form.get('phone')?.value || '').length;
    console.log('logitud');
    console.log(phoneNumberLength);
    if (phoneNumberLength <= 3) {
      //this.data.phone = phoneNumber.slice(0, 3);
      this.form.patchValue({
        phone: phoneNumber.slice(0, 3),
      });
    } else if (phoneNumberLength == 4) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 4);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 4),
      });
    } else if (phoneNumberLength == 5) {
      //this.data.phone = '(' + phoneNumber.slice(0, 3);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3),
      });
    } else if (phoneNumberLength == 6) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6);
      //console.log(this.data.phone);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6),
      });
    } else if (phoneNumberLength == 7) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6),
      });
    } else if (phoneNumberLength == 8) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6),
      });
    } else if (phoneNumberLength == 9) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6),
      });
    } else if (phoneNumberLength == 10) {
      //this.data.phone = '(' + phoneNumber.slice(0, 3) +   ') ' + phoneNumber.slice(3, 6) + ' - ' + phoneNumber.slice(6, 10);
      this.form.patchValue({
        phone:
          '(' +
          phoneNumber.slice(0, 3) +
          ') ' +
          phoneNumber.slice(3, 6) +
          ' - ' +
          phoneNumber.slice(6, 10),
      });
    }
  } */

  formatPhone(event: Event) {
    const input = event.target as HTMLInputElement;

    let digits = input.value.replace(/\D/g, '');
    digits = digits.slice(0, 10);

    let formatted = '';
    if (digits.length <= 3) {
      formatted = digits;
    } else if (digits.length <= 6) {
      formatted = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    } else {
      formatted = `(${digits.slice(0, 3)}) ${digits.slice(
        3,
        6
      )} - ${digits.slice(6)}`;
    }

    this.form.get('phone')?.setValue(formatted, { emitEvent: false });
  }

  cities() {
    this.http
      .get('https://restcountries.com/v3.1/all?fields=name')
      .subscribe((data: any[]) => {
        this.countries = data;
        this.countries = data.map((el) => el.name.common);
        this.countries.sort((a, b) => a.localeCompare(b));

        console.log('countries', this.countries);

        // Establecer "United States" como valor predeterminado si existe
        const EEUU = this.countries.find(
          (name) => name.toLowerCase() === 'united states'
        );

        //console.log('EEUU',EEUU)
        /* if (EEUU) {
          this.data.country = EEUU;
        } */
      });
  }

  openModalImg(img: string) {
    console.log('img', img);
    this.showModalImg = true;

    if (img == 'imgUser') {
      this.imgModal = this.imgUser;
      console.log('imgUser en modal', this.imgUser);
    }
  }

  closeModalImg() {
    this.showModalImg = false;
    this.imgModal = '';
  }

  get userImgUrl(): string {
    const img = this.form.get('img')?.value;

    return img
      ? `${this.apiUrl}/uploads/${img}`
      : './assets/img/faces/marc.jpg';
  }

  enableUpdate() {
    this.update = !this.update;
  }
}
